import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../shared/api.service';
import { PollItemData } from '../../../models/PollItemData';
import { PollDashboardResponse } from '../../../models/PollDashBoardResponse';
import { AuthenticationService } from '../../../shared/authentication.service';
import { LicenseService } from '../../../shared/licens.service';
import { SubsciptionData, LicenseData } from '../../../models/LicenseData';
import { Common } from '../../../shared/common';
import { VotingPeriod } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-pap-year',
  templateUrl: 'pap-year.component.html',
  styleUrls: ['./pap-year.component.less', '../../../shared/common.less'],
})

export class PapYearComponent implements OnInit {
  @Input() year: number;
  @Output() yearChange = new EventEmitter<number>();

  needPap: boolean = undefined;
  minDate: string;
  minYear: number;
  maxYear: number;

  constructor(
    private router: Router,
  ) {
    const today = new Date();
    this.minDate = today.toISOString().substring(0, 10);
    this.minYear = today.getFullYear();
    this.maxYear = today.getFullYear() + 1;
  }


  get electionYear(): number {
    return this.year;
  }

  set electionYear(value: number) {
    this.year = value || null;
    this.yearChange.emit(this.year);
  }
  
  onPeriodChange() {
    this.yearChange.emit(this.year);
  }

  goToPollCreation() {
    this.router.navigate(['/poll-creation']);
  }

  ngOnChanges(): void {
    
  }
  
  ngOnInit(): void {
  }
}
